import type { ModId, Reg } from '../store/types';
import type { Ctx } from './tipos';

/** Contexto mínimo (sem tela) para montar títulos fora da aba: vínculos, alertas, Planner. */
export function ctxDe(mod: ModId, regs: Reg[], moeda = '', cor = ''): Ctx {
  const mapa = new Map(regs.map(r => [r.id, r]));
  return { mod, regs, cor, moeda, filhos: (p, c) => regs.filter(r => r.pai === p && (!c || r.col === c)), porId: x => (x ? mapa.get(x) ?? null : null) };
}
